import { gql } from "@apollo/client";

const GET_ACCOUNTING_REMITTANCES_FOR_JOURNAL_ENTRY = gql`
  query GetAccountingRemittancesForJournalEntry($params: GetAccountingRemittanceParams!) {
    getAccountingRemittancesForJournalEntry(params: $params) {
      total
      page
      limit
      columns {
        key
        title
      }
      innerColumns {
        key
        title
      }
      items {
        remittanceId
        checkNumber
        checkDate
        jeTotal
        purchaser {
          purchaserId
          purchaserName
          purchaserKey
          qboCustomerId
          qboCustomerName
        }
        journalEntryLines {
          account
          qboAccountId
          qboAccountName
          description
          name
          postingType
          amount
          credits
          debits
          sourceType
          sourceTypes
          deductionIds
          remittanceItemIds
        }
      }
    }
  }
`;

export default GET_ACCOUNTING_REMITTANCES_FOR_JOURNAL_ENTRY;
